module.exports = __webpack_public_path__ + "static/media/9.0cf54335.jpg";